/**
 * Core-100 R3 (OD-11): the platform's credential "expiring" window, or null when it is not set (the default while
 * the owner's ruling is pending). Any read failure is treated as unset — the safe direction: a credential is then
 * shown with its expiry date and never called "expiring" on an invented basis.
 */
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useCredentialExpiringWindow(): number | null {
  const [days, setDays] = useState<number | null>(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await (supabase.from('credential_expiry_settings' as never) as unknown as {
          select: (c: string) => { maybeSingle: () => Promise<{ data: { expiring_window_days: number | null } | null; error: unknown }> };
        }).select('expiring_window_days').maybeSingle();
        if (alive && !res.error && typeof res.data?.expiring_window_days === 'number') setDays(res.data.expiring_window_days);
      } catch {
        /* unset */
      }
    })();
    return () => { alive = false; };
  }, []);
  return days;
}
